import React from 'react';
import {
  getBezierPath,
  getCurvedBezierPath,
  isDimmedEdge,
} from '../utils/geometry';

export const GraphEdges = ({
  edges,
  hoveredNodeId,
  anchors,
  linkMode,
  onEdgeClick,
}) => {
  return (
    <svg className="graph-lines">
      {edges.map((edge) => {
        const source = anchors[edge.source];
        const target = anchors[edge.target];
        if (!source || !target) return null;

        const d = getBezierPath(source.x, source.y, target.x, target.y, 0.08);

        // shortened points only for clickable path
        const dClick = getCurvedBezierPath(source, target, 20, 0.08);

        const dim = isDimmedEdge(edge, hoveredNodeId);
        const key = edge.id ?? `temp-${edge.source}-${edge.target}`;

        return (
          <g key={key}>
            {/* visible curved line */}
            <path
              d={d}
              stroke="brown"
              strokeWidth="1"
              fill="transparent"
              strokeDasharray={edge.isTemporary ? '6 4' : 'none'}
              style={{ opacity: dim ? 0.2 : 1 }}
              pointerEvents="none"
            />

            {/* invisible hit path for interaction */}
            {!edge.isTemporary && linkMode && (
              <path
                d={dClick}
                stroke="transparent"
                strokeWidth={12}
                fill="none"
                pointerEvents="stroke"
                style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  e.stopPropagation();
                  onEdgeClick(edge);
                }}
              />
            )}

            {/* red dot at source */}
            <circle
              cx={source.x}
              cy={source.y}
              r={6}
              fill="#c0392b"
              stroke="#800000"
              strokeWidth={1}
            />

            {/* red dot at target */}
            <circle
              cx={target.x}
              cy={target.y}
              r={6}
              fill="#c0392b"
              stroke="#800000"
              strokeWidth={1}
            />
          </g>
        );
      })}
    </svg>
  );
};
